import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=3deb5fbf&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"
import style0 from "./Setting.vue?vue&type=style&index=0&id=3deb5fbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deb5fbf",
  null
  
)

export default component.exports